import React from "react";
import WindowType2 from "../../../assets/booking-assets/window-type-2.svg";
import WindowType4 from "../../../assets/booking-assets/window-type-4.svg";

const WindowTypeButton = ({ windowType, handleClick, active }) => {
  const windowTypeDisplay = () => {
    switch (windowType) {
      case 2:
        return <WindowType2 />;
      case 4:
        return <WindowType4 />;
      default:
        return null;
    }
  };

  const windowTypeTextDisplay = () => {
    switch (windowType) {
      case 2:
        return (
          <div className="text-center">
            <h4
              className={
                "text-base text-main-600 mb-2" + (active ? " font-bold" : "")
              }
            >
              2-sidig fönsterputs
            </h4>
            <p className="text-sm text-gray-500">in- och utvändigt</p>
          </div>
        );
      case 4:
        return (
          <div className="text-center">
            <h4
              className={
                "text-base text-main-600 mb-2" + (active ? " font-bold" : "")
              }
            >
              4-sidig fönsterputs
            </h4>
            <p className="text-sm text-gray-500">
              in- och utvändigt samt mellan
            </p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={
        "WindowTypeButton cursor-pointer rounded-md border flex flex-col items-center justify-center py-8 px-10"
      }
      onClick={handleClick}
      style={{
        borderColor: active ? "#011E41" : "rgb(209,213,219)",
      }}
      aria-hidden="true"
    >
      <div className="mb-10">{windowTypeDisplay()}</div>
      <div>{windowTypeTextDisplay()}</div>
    </div>
  );
};

export default WindowTypeButton;
